var _style, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-online-doctor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n        svg#freepik_stories-online-doctor:not(.animated) .animable {\r\n            opacity: 0;\r\n        }\r\n\r\n        svg#freepik_stories-online-doctor.animated #freepik--cross-icon--inject-39 {\r\n            animation: 1.5s Infinite linear heartbeat;\r\n            animation-delay: 0s;\r\n        }\r\n\r\n        svg#freepik_stories-online-doctor.animated #freepik--pulse-icon--inject-39 {\r\n            animation: 1.5s Infinite linear heartbeat;\r\n            animation-delay: 0s;\r\n        }\r\n\r\n        svg#freepik_stories-online-doctor.animated #freepik--Character--inject-39 {\r\n            animation: 1.5s Infinite linear floating;\r\n            animation-delay: 0s;\r\n        }\r\n\r\n        svg#freepik_stories-online-doctor.animated #freepik--Chat--inject-39 {\r\n            animation: 1.5s Infinite linear wind;\r\n            animation-delay: 0s;\r\n        }\r\n\r\n        @keyframes heartbeat {\r\n            0% {\r\n                transform: scale(1);\r\n            }\r\n\r\n            10% {\r\n                transform: scale(1.1);\r\n            }\r\n\r\n            30% {\r\n                transform: scale(1);\r\n            }\r\n\r\n            40% {\r\n                transform: scale(1);\r\n            }\r\n\r\n            50% {\r\n                transform: scale(1.1);\r\n            }\r\n\r\n            60% {\r\n                transform: scale(1);\r\n            }\r\n\r\n            100% {\r\n                transform: scale(1);\r\n            }\r\n        }\r\n\r\n        @keyframes floating {\r\n            0% {\r\n                opacity: 1;\r\n                transform: translateY(0px);\r\n            }\r\n\r\n            50% {\r\n                transform: translateY(-10px);\r\n            }\r\n\r\n            100% {\r\n                opacity: 1;\r\n                transform: translateY(0px);\r\n            }\r\n        }\r\n\r\n        @keyframes wind {\r\n            0% {\r\n                transform: rotate(0deg);\r\n            }\r\n\r\n            25% {\r\n                transform: rotate(1deg);\r\n            }\r\n\r\n            75% {\r\n                transform: rotate(-1deg);\r\n            }\r\n        }\r\n\r\n        .animator-hidden {\r\n            display: none;\r\n        }\r\n    ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-39",
    className: "animable",
    style: {
      transformOrigin: "214.64px 209.774px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.75,180.64c-28.19-40.82-68.42-129-133.07-72.88-64.17,55.77-16.05,154.59,24.79,188C186.75,329.45,319.7,360,338.22,274.85,351,216.28,284.9,225.73,253.75,180.64Z",
    style: {
      fill: "#16A085",
      transformOrigin: "214.64px 209.774px"
    },
    id: "el5y1an0yp8w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el55wx41a5ml"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.75,180.64c-28.19-40.82-68.42-129-133.07-72.88-64.17,55.77-16.05,154.59,24.79,188C186.75,329.45,319.7,360,338.22,274.85,351,216.28,284.9,225.73,253.75,180.64Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.9,
      transformOrigin: "214.64px 209.774px"
    },
    className: "animable",
    id: "el1iiex6583pa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-39",
    className: "animable animator-hidden",
    style: {
      transformOrigin: "250px 416.24px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-39",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "250px 416.24px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--cross-icon--inject-39",
    className: "animable",
    style: {
      transformOrigin: "340.7px 314.54px"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 340.71,
    cy: 314.54,
    r: 31.68,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "340.71px 314.54px"
    },
    id: "elle7tyswb0p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.71,346.61a32.07,32.07,0,1,1,32.06-32.07A32.1,32.1,0,0,1,340.71,346.61Zm0-63.35A31.29,31.29,0,1,0,372,314.54,31.31,31.31,0,0,0,340.71,283.26Z",
    style: {
      fill: "#16A085",
      transformOrigin: "340.7px 314.54px"
    },
    id: "elh18ocgs7ndt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.61,
    y: 296.58,
    width: 10.2,
    height: 35.92,
    style: {
      fill: "#16A085",
      transformOrigin: "340.71px 314.54px"
    },
    id: "eluux0i62dbh9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elox47k16l6ts"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.61,
    y: 296.58,
    width: 10.2,
    height: 35.92,
    style: {
      fill: "#16A085",
      transformOrigin: "340.71px 314.54px",
      transform: "rotate(90deg)"
    },
    className: "animable",
    id: "el3hbvdox3uzg"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--pulse-icon--inject-39",
    className: "animable",
    style: {
      transformOrigin: "145.915px 95.275px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.11,75.07l-.68-.73a30.75,30.75,0,0,1,16.81-8.1l.14,1A29.74,29.74,0,0,0,126.11,75.07Z",
    style: {
      fill: "#16A085",
      transformOrigin: "133.905px 70.655px"
    },
    id: "el75go7ko6d6w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.71,86l-.93-.36a30.77,30.77,0,0,1,4-7.14l.8.6A30.24,30.24,0,0,0,118.71,86Z",
    style: {
      fill: "#16A085",
      transformOrigin: "120.18px 82.25px"
    },
    id: "els0a7hnljltc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.61,
    cy: 96.87,
    r: 27.44,
    style: {
      fill: "#16A085",
      transformOrigin: "146.61px 96.87px"
    },
    id: "el6u4oxh8f1f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,84.51a11.46,11.46,0,0,0-16.36-.15,11.45,11.45,0,0,0-16.35.15,11.71,11.71,0,0,0,.41,16.32l13,13a4.2,4.2,0,0,0,5.94,0l13-13A11.71,11.71,0,0,0,163,84.51Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "146.657px 98.0304px"
    },
    id: "elsm11gx39i4b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.61,108.86h0a1,1,0,0,1-.91-.67l-5.79-16.93-2.42,7.08a1,1,0,0,1-.95.67h-9.69a1,1,0,0,1,0-2h9l3.14-9.17a1,1,0,0,1,1.89,0l5.89,17.23,5.72-13.47a1,1,0,0,1,.86-.61,1,1,0,0,1,.93.51L157.3,97h9.11a1,1,0,0,1,0,2h-9.69a1,1,0,0,1-.88-.51l-2.37-4.24-5.94,14A1,1,0,0,1,146.61,108.86Z",
    style: {
      fill: "#16A085",
      transformOrigin: "146.63px 98.0135px"
    },
    id: "eluh3uweuerhq",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-39",
    className: "animable",
    style: {
      transformOrigin: "234.719px 246.802px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.86,381.2H194.49A12.26,12.26,0,0,1,182.13,368L199,118a14.44,14.44,0,0,1,14.15-13.25H317.54A12.26,12.26,0,0,1,329.9,118L313,368A14.43,14.43,0,0,1,298.86,381.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "256.017px 242.975px"
    },
    id: "el6h2bq45614a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,206.56h-2.63a3.42,3.42,0,0,1-3.45-3.7l3.23-47.79a4,4,0,0,1,3.95-3.7h2.63a3.42,3.42,0,0,1,3.45,3.7l-3.23,47.79A4,4,0,0,1,322,206.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "322.55px 178.965px"
    },
    id: "elyy8sf7b4le",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.48,174.68h-2.62a2.8,2.8,0,0,1-2.83-3l1.17-17.26a3.3,3.3,0,0,1,3.23-3h2.63a2.81,2.81,0,0,1,2.82,3l-1.17,17.26A3.29,3.29,0,0,1,197.48,174.68Z",
    style: {
      fill: "#16A085",
      transformOrigin: "196.955px 163.05px"
    },
    id: "eldjouevpmr4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.4,205.5h-2.63a2.8,2.8,0,0,1-2.82-3l1.17-17.26a3.3,3.3,0,0,1,3.23-3H197a2.81,2.81,0,0,1,2.82,3l-1.17,17.26A3.29,3.29,0,0,1,195.4,205.5Z",
    style: {
      fill: "#16A085",
      transformOrigin: "194.885px 193.87px"
    },
    id: "el5rho16g4nsm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.65,381.2H192.28A12.26,12.26,0,0,1,179.92,368L196.8,118A14.44,14.44,0,0,1,211,104.79H315.33A12.26,12.26,0,0,1,327.69,118L310.8,368A14.43,14.43,0,0,1,296.65,381.2Z",
    style: {
      fill: "#16A085",
      transformOrigin: "253.805px 242.995px"
    },
    id: "elye9dqx1ftk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el9wgvdpelac"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "181.02 365.2 197.5 121.24 326.56 121.24 310.08 365.2 181.02 365.2",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "253.79px 243.22px"
    },
    className: "animable",
    id: "el7eiolwohtn"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elfvziu9soin"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "231.97 365.2 278.03 121.24 306.94 121.24 260.88 365.2 231.97 365.2",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "269.455px 243.22px"
    },
    className: "animable",
    id: "elixvw2cq8v3m"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eleaisyg6nyln"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "210.13 365.2 256.19 121.24 270.84 121.24 224.78 365.2 210.13 365.2",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "240.485px 243.22px"
    },
    className: "animable",
    id: "elcv6g0vhhmp5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250.14,110.92h25.17a1.5,1.5,0,0,1,1.52,1.63h0a1.78,1.78,0,0,1-1.74,1.64H249.92a1.51,1.51,0,0,1-1.52-1.64h0A1.77,1.77,0,0,1,250.14,110.92Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "262.615px 112.555px"
    },
    id: "elmp6x1xpm89m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "244.9 405.25 236.08 406.09 232.9 385.74 241.72 384.89 244.9 405.25",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "238.9px 395.49px"
    },
    id: "elmap8sv117q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.07,401.78l9.24-2.87a.65.65,0,0,1,.82.38l3,7.33a1.52,1.52,0,0,1-1,2c-3.34,1-6.52,1.23-10.55,3-4.71,2-6.68,4.68-11.75,4.68-3.63,0-4.45-3.33-2.91-3.79,7-2.12,6.08-3.86,11.16-9.33A4.68,4.68,0,0,1,235.07,401.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "234.705px 407.587px"
    },
    id: "elae945crtkg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eljgimu7s94z"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "232.9 385.74 234.54 396.24 243.37 395.39 241.73 384.89 232.9 385.74",
    style: {
      opacity: 0.2,
      transformOrigin: "238.135px 390.565px"
    },
    className: "animable",
    id: "el9k99xj1dg6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M239.28,128.6c-11.57-1.36-23.08-.45-34.63,1.79a9.23,9.23,0,0,0-7.41,8c-1.25,11.06-2.68,35.85,2.9,72.83l47.28-4c.09-6.71-4.68-37.28-.74-69A8.47,8.47,0,0,0,239.28,128.6Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "221.76px 169.59px"
    },
    id: "el8l4uo4c6p9h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.75,138.08l1.69,3.38a1,1,0,0,0,.89.58l1.83.1a1.42,1.42,0,0,0,.91-.28l3.15-2.35-3.89-2.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "215.985px 139.411px"
    },
    id: "el0eugn5akt6k6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.22,141.17a3.08,3.08,0,0,0-2.13-.17c-1.49,5.25-3.12,20.32-3.29,27,4.52,13.17,6,14.5,6,14.5l2.29-15.85S216.52,150.44,216.22,141.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "214.945px 161.692px"
    },
    id: "elk2d78q74vx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.27,105.8c-1.08,6.52-2,18.43,2.68,22.64-3.43,3.6-7.92,7.77-15.62,8.24s-6.51-4.86-4.56-7.71c7.19-1.92,6.84-7.28,5.43-12.29Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "221.132px 121.255px"
    },
    id: "elyvay7kmrchp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.91,127.87a9.6,9.6,0,0,0-1.69-.55.67.67,0,0,0-.75.31c-.74,1.26-3,6.89-15.14,9.05,2,1.18,4.65,4.84,5.79,6.6,3.64-1.89,13.11-7.54,12.21-14.85A.74.74,0,0,0,233.91,127.87Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "225.36px 135.289px"
    },
    id: "eldthsmeyubz9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.84,129.27a.7.7,0,0,0-.82-.84,9.39,9.39,0,0,0-1.24.33,1,1,0,0,0-.26.15c-.93.86-6,8.18-1.25,14.1,1-1.61,4.45-5.26,8.06-6.33C212.91,135.14,211.23,132.27,211.84,129.27Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "211.299px 135.713px"
    },
    id: "elme8cat8n7cn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elt179fvuce5p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.35,110.24l-7.14,6.44a20.62,20.62,0,0,1,.72,3.56c2.76-.47,6.47-3.6,6.67-6.5A9.48,9.48,0,0,0,224.35,110.24Z",
    style: {
      opacity: 0.2,
      transformOrigin: "220.936px 115.24px"
    },
    className: "animable",
    id: "el1cqkgjmsrc6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M214.81,86.09c-6.16,2.41-6.56,7.47-6,13s6.58,1.87,7.92-1.59S223.34,82.75,214.81,86.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "214.098px 93.7045px"
    },
    id: "elm29n5xg49u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.46,97.12c-1.71,8.71-2.28,13.88-7.26,17.89-7.51,6-17.68.82-18.58-8.16-.81-8.09,2.12-21,11.09-23.52A11.72,11.72,0,0,1,234.46,97.12Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "221.616px 100.222px"
    },
    id: "elrcprp6px02b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.1,104.33c-7.33.39-5.78-3.77-4.45-6.16s-1.38-6.34.39-8.39c-3.16,1.26-6.49.22-10.72-2.72-3.28-2.29-7.39,6.86-11.39,2.27-3.78-4.33-.27-10.86,8.81-11.91s10.73,5.37,16.69,4.8,3.89,4.34,2.72,5.34C241.15,87.89,243.88,92.67,234.1,104.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "223.549px 90.8296px"
    },
    id: "eluhkene7jyq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,88.17a7.34,7.34,0,0,0,3.81-6.39C240.79,85.25,240.58,89.19,235,88.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "237.474px 85.0569px"
    },
    id: "elykfl0d26fe7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,106.42a6,6,0,0,0,4.58-1.08.2.2,0,0,0,0-.29.21.21,0,0,0-.29,0,5.77,5.77,0,0,1-5.09.79.23.23,0,0,0-.27.14.21.21,0,0,0,.14.26A5.29,5.29,0,0,0,216,106.42Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "217.782px 105.75px"
    },
    id: "elpms0klyg7nd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.23,107a8.52,8.52,0,0,1-5.59,3.22c-2.91.38-3.88-2.33-2.66-4.86,1.11-2.28,4-5.22,6.68-4.43S237.91,104.8,236.23,107Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "232.321px 105.527px"
    },
    id: "elnglo5oi94y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.34,296.37c.35-26.11,3.69-88.3,3.69-88.3l-36.86,3.11s7.33,64.09,11.75,90.73c4.6,27.69,18.71,92.56,18.71,92.56l15-1.28S240.15,316.56,233.34,296.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "222.9px 301.27px"
    },
    id: "elxqgletikc4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229.73 394.88 247.52 393.37 246.82 387.63 228.28 388.87 229.73 394.88",
    style: {
      fill: "#16A085",
      transformOrigin: "237.9px 391.255px"
    },
    id: "elxk82fcm57m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.32,97.64c-.09.71-.55,1.25-1,1.2s-.76-.67-.66-1.39.55-1.25,1-1.2S221.42,96.93,221.32,97.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "220.49px 97.545px"
    },
    id: "elfibheb2xr8b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.16,97c-.09.72-.55,1.25-1,1.2s-.76-.67-.66-1.38.55-1.25,1-1.2S213.26,96.25,213.16,97Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "212.33px 96.91px"
    },
    id: "elxz5xf8h0kx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.46,97.84a24.82,24.82,0,0,1-4.3,5c1.06,1.11,3.25.81,3.25.81Z",
    style: {
      fill: "rgb(237, 137, 62)",
      transformOrigin: "213.31px 100.763px"
    },
    id: "el85vtiac93ka",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpu9xb2kfrtq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208,97.18c-.15,1.14,1,2.09,2.59,2.29s3.06-.67,3.2-1.81",
    style: {
      fill: "#16A085",
      opacity: 0.4,
      transformOrigin: "210.888px 98.3394px"
    },
    className: "animable",
    id: "elht74wb6qb2t"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elfdtlwvy9s15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.45,98.24c-.22,1.13.89,2.15,2.45,2.45s3.09-.5,3.3-1.62",
    style: {
      fill: "#16A085",
      opacity: 0.4,
      transformOrigin: "220.311px 99.4967px"
    },
    className: "animable",
    id: "el7ujc1jtedcm"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220.52,101a4.89,4.89,0,0,1-.54,0,3.8,3.8,0,0,1-2.07-.93,2.08,2.08,0,0,1-.72-1.77,5,5,0,0,0-1.6-.4,3.49,3.49,0,0,0-1.69,0c-.14,1.22-1.66,2.06-3.36,1.85a3.72,3.72,0,0,1-2.07-.92,2.1,2.1,0,0,1-.72-1.77l.48.06a1.61,1.61,0,0,0,.57,1.36,3.24,3.24,0,0,0,1.8.79c1.44.19,2.72-.48,2.85-1.48.07-.56,1.23-.52,2.19-.4s2.1.39,2,.94a1.6,1.6,0,0,0,.57,1.36,3.44,3.44,0,0,0,3.75.48,1.6,1.6,0,0,0,.9-1.17l0-.24,12.34,1.59-.06.48-11.88-1.53a2.15,2.15,0,0,1-1.1,1.29A3.53,3.53,0,0,1,220.52,101Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "221.471px 99.0337px"
    },
    id: "elvo7hpymeio",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.46,94.5a.36.36,0,0,0,.2-.06.43.43,0,0,0,.16-.58,4,4,0,0,0-3.14-2.1.43.43,0,0,0-.45.4.42.42,0,0,0,.39.44h0a3.21,3.21,0,0,1,2.47,1.7A.41.41,0,0,0,224.46,94.5Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "223.052px 93.1299px"
    },
    id: "elvjh2n0oarzk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.52,93.37a.43.43,0,0,0,.37-.15,3.41,3.41,0,0,1,2.76-1.34.42.42,0,0,0,.46-.38.41.41,0,0,0-.36-.46,4.3,4.3,0,0,0-3.5,1.65.42.42,0,0,0,.05.59A.51.51,0,0,0,210.52,93.37Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "212.133px 92.2053px"
    },
    id: "elp5334of3rrm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.05,292.16c-7.65-39.32-9.37-70.07-16.63-85l-35.71,4s21.27,58.59,31.66,83.6c10.79,26,32.09,70.42,32.09,70.42H293.3S276.65,310.07,264.05,292.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "252.505px 286.17px"
    },
    id: "elwg35kfojkma",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.86,143.31,147,140.87a3.22,3.22,0,0,0-4.06.47l-2.62,2.76a3,3,0,0,0,.26,4.37l1.87,1.6a15.25,15.25,0,0,0,5.57,3l5.65,1.67,3.71-4C158.51,146.57,150.86,143.31,150.86,143.31Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "148.496px 147.548px"
    },
    id: "el2v6a29ps5xj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,141.44c-1.4,3.42-2.77,6.6-4.26,9.85s-3,6.46-4.67,9.65-3.45,6.36-5.47,9.54c-1,1.58-2.11,3.16-3.37,4.75a30.34,30.34,0,0,1-4.6,4.77,16.51,16.51,0,0,1-3.69,2.28c-.42.16-.81.32-1.27.46l-.7.19a8.35,8.35,0,0,1-1.07.19,10,10,0,0,1-3.64-.26,14.82,14.82,0,0,1-4.18-1.91,24,24,0,0,1-2.75-2,65.72,65.72,0,0,1-7.95-8.27c-2.33-2.8-4.53-5.61-6.64-8.48s-4.14-5.69-6.22-8.7l11.06-7.14a149.17,149.17,0,0,0,11.56,16.15,54.44,54.44,0,0,0,6.37,6.59,12.56,12.56,0,0,0,1.41,1c.37.25.74.35.48.26a2.56,2.56,0,0,0-1.08-.06,2.38,2.38,0,0,0-.43.08h-.08c-.05,0-.05,0-.06,0a6.05,6.05,0,0,0,.65-.49,18.45,18.45,0,0,0,2.47-2.74c.85-1.14,1.7-2.42,2.51-3.75a91.72,91.72,0,0,0,4.52-8.54c1.4-3,2.75-6,4-9.12s2.44-6.29,3.45-9.32Z",
    style: {
      fill: "#16A085",
      transformOrigin: "177.76px 159.801px"
    },
    id: "el4lco9iex7dh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elb210i615a1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "177.76px 159.801px"
    },
    className: "animable",
    id: "elsn9pxsrszrm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208,141.44c-1.4,3.42-2.77,6.6-4.26,9.85s-3,6.46-4.67,9.65-3.45,6.36-5.47,9.54c-1,1.58-2.11,3.16-3.37,4.75a30.34,30.34,0,0,1-4.6,4.77,16.51,16.51,0,0,1-3.69,2.28c-.42.16-.81.32-1.27.46l-.7.19a8.35,8.35,0,0,1-1.07.19,10,10,0,0,1-3.64-.26,14.82,14.82,0,0,1-4.18-1.91,24,24,0,0,1-2.75-2,65.72,65.72,0,0,1-7.95-8.27c-2.33-2.8-4.53-5.61-6.64-8.48s-4.14-5.69-6.22-8.7l11.06-7.14a149.17,149.17,0,0,0,11.56,16.15,54.44,54.44,0,0,0,6.37,6.59,12.56,12.56,0,0,0,1.41,1c.37.25.74.35.48.26a2.56,2.56,0,0,0-1.08-.06,2.38,2.38,0,0,0-.43.08h-.08c-.05,0-.05,0-.06,0a6.05,6.05,0,0,0,.65-.49,18.45,18.45,0,0,0,2.47-2.74c.85-1.14,1.7-2.42,2.51-3.75a91.72,91.72,0,0,0,4.52-8.54c1.4-3,2.75-6,4-9.12s2.44-6.29,3.45-9.32Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "177.76px 159.801px"
    },
    id: "el6v3l9lwy4ub",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M234.18,126.09c-3.75,7-17.1,33.67-18.72,50.13-5.91-15-4.62-48.18-4.62-48.18a44.43,44.43,0,0,0-12.27,3A7.41,7.41,0,0,0,194,137.3a262.07,262.07,0,0,0,1.62,51.47c4.15,32.3,8,82.53,8,82.53s33.05-1.38,58.55-6.76c-3.11-24.69-13.75-66.07-13.85-77.15-.12-14.26.21-42.14.66-53.78a6.89,6.89,0,0,0-5.52-7.07A34.57,34.57,0,0,0,234.18,126.09Z",
    style: {
      fill: "#16A085",
      transformOrigin: "227.791px 198.631px"
    },
    id: "elrisof9ebq3g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elyzvymfa9y5b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.18,126.09c-3.75,7-17.1,33.67-18.72,50.13-5.91-15-4.62-48.18-4.62-48.18a44.43,44.43,0,0,0-12.27,3A7.41,7.41,0,0,0,194,137.3a262.07,262.07,0,0,0,1.62,51.47c4.15,32.3,8,82.53,8,82.53s33.05-1.38,58.55-6.76c-3.11-24.69-13.75-66.07-13.85-77.15-.12-14.26.21-42.15.66-53.79a6.78,6.78,0,0,0-5.21-7A34.31,34.31,0,0,0,234.18,126.09Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "227.791px 198.63px"
    },
    className: "animable",
    id: "elu4xjwpyuj3n"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M226.39,265.94c-5.74-31.67-10.29-78.14-10.66-83.73l.51,0c.37,5.59,4.93,52,10.66,83.67Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "221.315px 224.075px"
    },
    id: "elog66af4j59e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.53,209.6H193.05a2.85,2.85,0,0,1-2.64-2.17l-10.19-47.37a1.7,1.7,0,0,1,1.7-2.17h30.47a2.85,2.85,0,0,1,2.65,2.17l10.19,47.37A1.7,1.7,0,0,1,223.53,209.6Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "202.725px 183.745px"
    },
    id: "elpfxfey7t3r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.58,210h-31a2.91,2.91,0,0,1-2.69-2.21l-10.37-48.17a1.74,1.74,0,0,1,1.74-2.21h31a2.91,2.91,0,0,1,2.69,2.21l10.36,48.17A1.73,1.73,0,0,1,222.58,210Z",
    style: {
      fill: "#16A085",
      transformOrigin: "201.417px 183.705px"
    },
    id: "eluoyfhyi78oj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.13,182.82l-7.71-.29a6.61,6.61,0,0,0-2.71.48l-4,1.6a3,3,0,0,0-1.64,4l1.6,3.46a3.24,3.24,0,0,0,3.7,1.74l4.41-1.1s8.28-.66,8.58-5Z",
    style: {
      fill: "rgb(255, 181, 115)",
      transformOrigin: "219.087px 188.216px"
    },
    id: "elje285o5pbo8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.42,130.38c1.91,3,3.66,5.74,5.38,8.68s3.41,5.85,5,8.89,3.1,6.18,4.47,9.54a48.59,48.59,0,0,1,1.82,5.39,22.59,22.59,0,0,1,.88,6.87v.39a1.92,1.92,0,0,1,0,.2c0,.36-.1.72-.17,1.08s-.16.64-.26,1-.21.55-.32.83a11.17,11.17,0,0,1-1.46,2.42,17.45,17.45,0,0,1-2.77,2.76,36.41,36.41,0,0,1-5,3.31,95.27,95.27,0,0,1-9.52,4.54c-3.15,1.34-6.29,2.56-9.45,3.71s-6.27,2.26-9.56,3.36l-3.81-12.6c3-.82,6.06-1.83,9.05-2.85s6-2.16,8.84-3.35a77.92,77.92,0,0,0,8.14-3.93,23.49,23.49,0,0,0,3.17-2.11,3.81,3.81,0,0,0,.7-.69,1.07,1.07,0,0,0-.2.33c0,.09-.05.15-.1.26a2.37,2.37,0,0,0-.09.36,2.43,2.43,0,0,0-.08.47c0,.06,0,.07,0,.05v-.07a11.76,11.76,0,0,0-.55-2.79,36.08,36.08,0,0,0-1.42-3.85,78.1,78.1,0,0,0-4.14-8.07c-1.56-2.68-3.22-5.36-5-8s-3.6-5.27-5.43-7.67Z",
    style: {
      fill: "#16A085",
      transformOrigin: "243.814px 161.865px"
    },
    id: "eliitgwk4nezj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elp04uqotkrqd"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      transformOrigin: "243.814px 161.865px"
    },
    className: "animable",
    id: "elem5pzvx5ibp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M247.42,130.38c1.91,3,3.66,5.74,5.38,8.68s3.41,5.85,5,8.89,3.1,6.18,4.47,9.54a48.59,48.59,0,0,1,1.82,5.39,22.59,22.59,0,0,1,.88,6.87v.39a1.92,1.92,0,0,1,0,.2c0,.36-.1.72-.17,1.08s-.16.64-.26,1-.21.55-.32.83a11.17,11.17,0,0,1-1.46,2.42,17.45,17.45,0,0,1-2.77,2.76,36.41,36.41,0,0,1-5,3.31,95.27,95.27,0,0,1-9.52,4.54c-3.15,1.34-6.29,2.56-9.45,3.71s-6.27,2.26-9.56,3.36l-3.81-12.6c3-.82,6.06-1.83,9.05-2.85s6-2.16,8.84-3.35a77.92,77.92,0,0,0,8.14-3.93,23.49,23.49,0,0,0,3.17-2.11,3.81,3.81,0,0,0,.7-.69,1.07,1.07,0,0,0-.2.33c0,.09-.05.15-.1.26a2.37,2.37,0,0,0-.09.36,2.43,2.43,0,0,0-.08.47c0,.06,0,.07,0,.05v-.07a11.76,11.76,0,0,0-.55-2.79,36.08,36.08,0,0,0-1.42-3.85,78.1,78.1,0,0,0-4.14-8.07c-1.56-2.68-3.22-5.36-5-8s-3.6-5.27-5.43-7.67Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "243.814px 161.865px"
    },
    id: "elr0zlu27f35g",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M237.3,165.08a.39.39,0,0,1-.33-.19.39.39,0,0,1,.12-.55l1.56-1a8.5,8.5,0,0,0,3.8-8.86l-3.14-15.9a5.38,5.38,0,0,0-10.46-.44l-4.45,15.59a8.47,8.47,0,0,0,3,9.14l1.48,1.12a.4.4,0,0,1,.07.56.39.39,0,0,1-.55.07L227,163.51a9.28,9.28,0,0,1-3.33-10l4.46-15.59a6.18,6.18,0,0,1,12,.5l3.14,15.91a9.28,9.28,0,0,1-4.15,9.68l-1.57,1A.33.33,0,0,1,237.3,165.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "233.377px 149.265px"
    },
    id: "el7qi55ht003w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.7,138.91h0l-11.23-.47a.4.4,0,0,1-.38-.42.42.42,0,0,1,.42-.38l11.22.47a.4.4,0,0,1,.38.42A.39.39,0,0,1,239.7,138.91Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "234.1px 138.275px"
    },
    id: "elkxpel9y1hs8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.24,134.25a.41.41,0,0,1-.4-.39c0-2-.62-5.47-2.49-6.23a.4.4,0,1,1,.3-.74c2.77,1.14,3,6.36,3,7a.41.41,0,0,1-.39.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "232.864px 130.575px"
    },
    id: "ell4ub6pch8i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.89,147.84h-.08a.4.4,0,0,1-.31-.47c1.32-6.57,6.78-16.94,11.59-20a.39.39,0,0,1,.54.13.38.38,0,0,1-.12.54c-4.65,2.94-9.95,13-11.23,19.47A.4.4,0,0,1,199.89,147.84Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "205.594px 137.576px"
    },
    id: "elgoj2whq2vau",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.17,148.87c-.62,1.59-2,2.55-3,2.14s-1.39-2-.77-3.63,2-2.55,3-2.13S203.8,147.28,203.17,148.87Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "201.287px 148.127px"
    },
    id: "eluojbz91x8ja",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.57,164.36c0,.74-.46,1.33-.95,1.31s-.87-.64-.84-1.39.46-1.34.95-1.31S229.6,163.61,229.57,164.36Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "228.675px 164.32px"
    },
    id: "ell3zkqpwvso",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.19,164.72c0,.74-.45,1.33-.95,1.31s-.86-.64-.83-1.39.45-1.33,1-1.31S238.22,164,238.19,164.72Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "237.3px 164.68px"
    },
    id: "elr0ysislrix",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chat--inject-39",
    className: "animable",
    style: {
      transformOrigin: "338.955px 183.005px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.77,150.85l-1-.06a15.41,15.41,0,0,0-15.49-16.61v-1a16.4,16.4,0,0,1,16.49,17.67Z",
    style: {
      fill: "#16A085",
      transformOrigin: "399.55px 142.015px"
    },
    id: "el0w7yk7j0ulo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el8g0d6bytkp9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.54,
    y: 159.04,
    width: 8.28,
    height: 1,
    style: {
      fill: "#16A085",
      transformOrigin: "406.68px 159.54px",
      transform: "rotate(-85.9958deg)"
    },
    className: "animable",
    id: "elwepe9wk08mq"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M391.28,136.68h-69a15.18,15.18,0,0,0-14.88,13.94l-.63,9.29a12.91,12.91,0,0,0,13,13.94h69l13.38,8.25,2.12-31.48A12.9,12.9,0,0,0,391.28,136.68Z",
    style: {
      fill: "#16A085",
      transformOrigin: "355.52px 159.39px"
    },
    id: "elu7wutftokq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.87,
    y: 149.99,
    width: 63.91,
    height: 2.32,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "355.825px 151.15px"
    },
    id: "elwvjd0h7nkvs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 339.77,
    y: 158.22,
    width: 47.45,
    height: 2.32,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "363.495px 159.38px"
    },
    id: "elf3nbxjik96q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.48,186.38H358a13.19,13.19,0,0,1,13.29,14.25l-.64,9.5a15.53,15.53,0,0,1-15.21,14.25H284.91l-14.82,8.45,2.18-32.2A15.52,15.52,0,0,1,287.48,186.38Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "320.711px 209.605px"
    },
    id: "elryqpu4v3un",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elq5id1pzwvt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.48,186.38H358a13.19,13.19,0,0,1,13.29,14.25l-.64,9.5a15.53,15.53,0,0,1-15.21,14.25H284.91l-14.82,8.45,2.18-32.2A15.52,15.52,0,0,1,287.48,186.38Z",
    style: {
      fill: "#16A085",
      opacity: 0.15,
      transformOrigin: "320.711px 209.605px"
    },
    className: "animable",
    id: "elhx03m90x5jn"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ellovbzz6pvx"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 289.06,
    y: 199.99,
    width: 65.36,
    height: 2.38,
    style: {
      fill: "#16A085",
      opacity: 0.5,
      transformOrigin: "321.74px 201.18px"
    },
    className: "animable",
    id: "el4ibymotupnm"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elhyqf7z9j2el"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 288.49,
    y: 208.4,
    width: 25.83,
    height: 2.38,
    style: {
      fill: "#16A085",
      opacity: 0.5,
      transformOrigin: "301.405px 209.59px"
    },
    className: "animable",
    id: "elks01qg7qcvg"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el1zbg8cb0epe"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 320.65,
    y: 208.4,
    width: 16.5,
    height: 2.38,
    style: {
      fill: "#16A085",
      opacity: 0.5,
      transformOrigin: "328.9px 209.59px"
    },
    className: "animable",
    id: "elem2oqsakn4o"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookImg);
export default __webpack_public_path__ + "static/media/book-img.947ad3ec8d2cdc0bd9212243215c3091.svg";
export { ForwardRef as ReactComponent };